// What a post is called, the same on every surface that names it: Posts, the calendar and the
// dashboard (R17, R27). A post made by hand has no generated headline; its caption names it.
import { captionTitle, type PostFormat } from '@str/shared';
import { draftName, hostWords } from './draft-name';
import { kindLabel } from './home';
import { SHAPES } from './wizard';

type Named = { title: string | null; caption: string | null; brief: string; format: PostFormat };

/** The host's name for the post, or '' when the only words are a shape's brief. */
function hostName(p: Named): string {
  const named = p.title?.trim() || captionTitle(p.caption);
  if (named) return named;
  // A shape's brief is an instruction to the generator and is never a name.
  const template =
    hostWords(p.brief) === p.brief && SHAPES.some((s) => p.brief.startsWith(s.brief));
  return template ? '' : draftName(p);
}

/**
 * What a post is called on its card: its title, else the first sentence of the host's caption,
 * else the host's own line. With nothing of the host's, the post is called by its format, as the
 * dashboard does.
 */
export function postName(p: Named): string {
  return hostName(p) || kindLabel({ format: p.format, shapeId: null });
}

/** "Carousel · Three rooms, one view": the format, then the name; the format alone without one. */
export function postLine(p: Named): string {
  const name = hostName(p);
  return name ? `${p.format} · ${name}` : p.format;
}
